module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_9016.479a757a.png";